var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightPagiHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1225 8.4675L7.94246 5.2875C7.87274 5.2172 7.78978 5.1614 7.69839 5.12333C7.607 5.08525 7.50897 5.06565 7.40996 5.06565C7.31095 5.06565 7.21292 5.08525 7.12152 5.12333C7.03013 5.1614 6.94718 5.2172 6.87746 5.2875C6.73777 5.42802 6.65936 5.61811 6.65936 5.81625C6.65936 6.01439 6.73777 6.20447 6.87746 6.345L9.53246 9L6.87746 11.655C6.73777 11.7955 6.65936 11.9856 6.65936 12.1837C6.65936 12.3819 6.73777 12.572 6.87746 12.7125C6.94754 12.782 7.03065 12.837 7.12203 12.8743C7.21341 12.9116 7.31125 12.9306 7.40996 12.93C7.50866 12.9306 7.60651 12.9116 7.69789 12.8743C7.78927 12.837 7.87238 12.782 7.94246 12.7125L11.1225 9.5325C11.1928 9.46277 11.2485 9.37982 11.2866 9.28843C11.3247 9.19703 11.3443 9.099 11.3443 9C11.3443 8.90099 11.3247 8.80296 11.2866 8.71156C11.2485 8.62017 11.1928 8.53722 11.1225 8.4675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPagiHover);
export default __webpack_public_path__ + "static/media/right_pagi_hover.a9ea5aeee629db7f6907e71472e97171.svg";
export { ForwardRef as ReactComponent };